import { FocusEvent } from 'react';
import { useWatch } from 'react-hook-form';
import { Input, LabeledContainer } from '@schibsted-svp/react-ui';
import { MediaLiveInputType } from 'services/admin-bff/contants';
import * as validatorHelpers from 'components/video/live/form/validators';
import { getInputUrl, getVideoKey } from 'components/video/live/MediaLiveInputInfoDialog/MediaLiveInputInfoDialog';
import { useMediaLiveInputFormContext } from './hooks';
import { MediaLivePushInfo } from './MediaLivePushInfo';
import css from './MediaLiveNetworkUrl.module.scss';

const handleFocus = (event: FocusEvent<HTMLInputElement>) => event.target.select();

type MediaLiveNetworkUrlProps = {
    inputUrl: string | undefined;
    backupInputUrl?: string;
};

export function MediaLiveNetworkUrl({ inputUrl = '', backupInputUrl }: MediaLiveNetworkUrlProps) {
    const { formApi } = useMediaLiveInputFormContext();
    const {
        register,
        control,
        formState: { errors },
    } = formApi;

    const inputType = useWatch({ name: 'inputType', control });
    const srtEnabled = useWatch({ name: 'srtEnabled', control });

    const urlValidator = {
        required: validatorHelpers.required,
        url: validatorHelpers.url,
        hlsRtmpOrSrtUrl: validatorHelpers.hlsRtmpOrSrtUrl,
    };

    if (!inputUrl) {
        return inputType === MediaLiveInputType.PUSH ? (
            <MediaLivePushInfo variant={srtEnabled ? 'url-only' : 'default'} />
        ) : (
            <LabeledContainer label="Network Input URL">
                <Input
                    {...register('pull-source', { validate: urlValidator, shouldUnregister: true })}
                    error={errors?.['pull-source']?.message}
                />
            </LabeledContainer>
        );
    }

    if (inputUrl?.startsWith('srt')) {
        return (
            <>
                <LabeledContainer label="Network Input URL">
                    <Input value={inputUrl} key={inputUrl} onFocus={handleFocus} readOnly />
                </LabeledContainer>
                {backupInputUrl && (
                    <LabeledContainer label="Backup Network Input URL">
                        <Input value={backupInputUrl} key={backupInputUrl} onFocus={handleFocus} readOnly />
                    </LabeledContainer>
                )}
            </>
        );
    }

    return (
        <div className={css.container}>
            <LabeledContainer label="Network Input URL">
                <Input value={getInputUrl(inputUrl)} onFocus={handleFocus} readOnly />
            </LabeledContainer>
            <LabeledContainer label="Video key">
                <Input value={getVideoKey(inputUrl)} onFocus={handleFocus} readOnly />
            </LabeledContainer>
        </div>
    );
}
